import React from 'react'
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import { requiredHelperNode } from './requiredFieldHelperText'

interface StudyDetailsFieldProps {
    isVendor: boolean
    onChange: (val: boolean) => void
    vendorDetails: string
    onVendorDetailsChange: (val: string) => void
    disabled?: boolean
    vendorDetailsRequired?: boolean
    vendorDetailsError?: string
}

const StudyDetailsField: React.FC<StudyDetailsFieldProps> = ({
    isVendor,
    onChange,
    vendorDetails,
    onVendorDetailsChange,
    disabled,
    vendorDetailsRequired,
    vendorDetailsError,
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="16x600" sx={{ display: 'block' }}>
                Study Details
            </Typography>
            <FormControl>
                <RadioGroup
                    row
                    value={isVendor ? 'outsourced' : 'internal'}
                    onChange={(e) => onChange(e.target.value === 'outsourced')}
                >
                    <FormControlLabel
                        value="internal"
                        control={<Radio color="primary" disabled={disabled} />}
                        label="Internal"
                    />
                    <FormControlLabel
                        value="outsourced"
                        control={<Radio color="primary" disabled={disabled} />}
                        label="Outsourced"
                    />
                </RadioGroup>
            </FormControl>
            {isVendor && (
                <TextField
                    fullWidth
                    multiline
                    required={vendorDetailsRequired}
                    label="Vendor Details"
                    placeholder="Enter Vendor Details"
                    value={vendorDetails}
                    disabled={disabled}
                    error={!!vendorDetailsError}
                    helperText={requiredHelperNode(vendorDetailsError, vendorDetailsRequired)}
                    onFocus={(e) => e.target.setAttribute('autocomplete', 'off')}
                    onChange={(e) => onVendorDetailsChange(e.target.value)}
                    sx={{ '.MuiInputBase-root': { borderRadius: '12px' } }}
                />
            )}
        </Box>
    )
}

export default StudyDetailsField
